import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Box, Typography } from '@mui/material';

export default function TableWithBars({ columns, rows, barColumn, barColor = '#3b82f6', maxBar }) {
  const maxValue = maxBar ?? Math.max(1, ...rows.map((r) => Number(r[barColumn]) || 0));
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          {columns.map((c) => (
            <TableCell key={c.key} align={c.align || 'left'} sx={{ fontWeight: 600 }}>
              {c.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.length === 0 ? (
          <TableRow>
            <TableCell colSpan={columns.length} align="center" sx={{ color: 'text.secondary', py: 3 }}>
              No data.
            </TableCell>
          </TableRow>
        ) : rows.map((r, i) => (
          <TableRow key={r.id ?? i} hover>
            {columns.map((c) => {
              const value = c.render ? c.render(r) : r[c.key];
              if (c.key === barColumn) {
                const num = Number(r[barColumn]) || 0;
                const pct = (num / maxValue) * 100;
                return (
                  <TableCell key={c.key} align={c.align || 'left'} sx={{ minWidth: 140 }}>
                    <Box sx={{ position: 'relative', height: 18, bgcolor: 'rgba(0,0,0,0.04)', borderRadius: 0.5, overflow: 'hidden' }}>
                      <Box sx={{ width: `${pct}%`, height: '100%', bgcolor: barColor, opacity: 0.7 }} />
                      <Typography variant="caption" sx={{
                        position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'flex-end',
                        pr: 1, fontWeight: 500,
                      }}>
                        {value}
                      </Typography>
                    </Box>
                  </TableCell>
                );
              }
              return (
                <TableCell key={c.key} align={c.align || 'left'}>
                  {value}
                </TableCell>
              );
            })}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
